import { render, staticRenderFns } from "./DualScroll.vue?vue&type=template&id=ef75d46a&scoped=true"
import script from "./DualScroll.vue?vue&type=script&lang=js"
export * from "./DualScroll.vue?vue&type=script&lang=js"
import style0 from "./DualScroll.vue?vue&type=style&index=0&id=ef75d46a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../ChatGenial-hom-sync/client/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef75d46a",
  null
  
)

export default component.exports